"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const PricingPoint_1 = require("../PricingPoint");
class PricingTableCell {
    constructor({ supportingPlaybackTimeLength, supportingAspectRatioKey, prices, }) {
        this.toJSON = () => ({
            supportingPlaybackTimeLength: this.supportingPlaybackTimeLength,
            supportingAspectRatioKey: this.supportingAspectRatioKey,
            prices: this.prices,
        });
        // creative formatを元にpointを返す
        this.getPoint = (creativeFormat, itemType) => {
            const price = this.prices.find(_price => _price.key == creativeFormat.getPricingKey(itemType));
            return price;
        };
        this.supportingPlaybackTimeLength = supportingPlaybackTimeLength;
        this.supportingAspectRatioKey = supportingAspectRatioKey;
        this.prices = prices;
    }
}
PricingTableCell.fromJSON = (json) => {
    const { supportingPlaybackTimeLength, supportingAspectRatioKey, prices } = Object.assign({}, json);
    if (typeof supportingAspectRatioKey !== 'string')
        throw new Error('.supportingAspectRatioKey must be an string');
    if (!Array.isArray(prices))
        throw new Error('.prices must be a Array');
    return new PricingTableCell({
        supportingPlaybackTimeLength,
        supportingAspectRatioKey,
        prices: prices ? prices.map((_price) => PricingPoint_1.default.fromJSON(_price)) : [],
    });
};
exports.default = PricingTableCell;
